import React, { useEffect } from 'react';
import { use } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import Loader from './Loader';
import { role } from '../../helpers/functions';
import { ROLE_NAME } from '../../helpers/constant';
import { message } from 'antd';

const LinkedInAuthMiddlewareTwo = () => {
  const location = useLocation();
  const { code, loginType } = location.state || {};
  const dispatch = useDispatch();

  const { linkedin_auth_middleware } = useSelector(state => state.auth);

  const { isSignupLoading, signupStatus, signupData, isLoginLoading, loginMsg } = useSelector(
    state => state.auth,
  );

  useEffect(() => {
    if (code && linkedin_auth_middleware === '') {
      dispatch({ type: 'LINKEDIN_AUTH_MIDDLEWARE_URL', params: code });
    }
  }, []);
  useEffect(() => {
    if (linkedin_auth_middleware?.success == false) {
      message.error(linkedin_auth_middleware?.message || "something went wrong please try again");
      setTimeout(() => {
        window.location.href = '/login';
      }, 3000);
    }
    if (!code) {
      window.location.href = '/';
    }

  }, [linkedin_auth_middleware])


  useEffect(() => {
    if (linkedin_auth_middleware === '' || linkedin_auth_middleware?.success == false) return;

    const data = linkedin_auth_middleware;
    if (data?.token) {
      dispatch({ type: 'LOGIN_REQUEST', formData: data });
    } else if (loginType === 'customer') {
      window.location.href =
        '/signup?email=' +
        (data?.email || '') +
        '&first_name=' +
        (data?.first_name || '') +
        '&last_name=' +
        (data?.last_name || '');
    } else {
      localStorage.setItem('redirectLink', `${window.location.origin}/expert/profile`);
      localStorage.setItem('expertFirstTimeLogin', true);
      window.location.href =
        '/expert/signup?email=' +
        (data?.email || '') +
        '&first_name=' +
        (data?.first_name || '') +
        '&last_name=' +
        (data?.last_name || '');
    }
  }, [linkedin_auth_middleware]);

  useEffect(() => {
    if (!isLoginLoading && loginMsg === 'success') {
      dispatch({ type: 'CLEAR_LOGIN_DATA' });
      if (localStorage.getItem('redirectLink')) {
        let tmoURL = localStorage.getItem('redirectLink');
        localStorage.removeItem('redirectLink');
        window.location.href = tmoURL;
      } else {
        if (role() === ROLE_NAME.ADMIN) {
          window.location.href = '/admin/requests';
        } else if (role() === ROLE_NAME.EXPERT) {
          window.location.href = '/dashboard/expert/request';
        } else {
          window.location.href = '/dashboard/customer';
        }
      }
    }
  }, [isLoginLoading, loginMsg]);

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loader />
    </div>
  );
};

export default LinkedInAuthMiddlewareTwo;
